<template>
    <div class="container">
        <div class="header">
            <div class="swiper-container top-swiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide slide-item">
                      <img src="https://s21.lgstatic.com/growth/activity/20210514/1620972668200.png">
                    </div>
                    <div class="swiper-slide slide-item">
                      <img src="https://s21.lgstatic.com/growth/activity/20210305/1614911259038.png">
                    </div>
                    <!-- <div class="swiper-slide slide-item">
                      <img src="https://s21.lgstatic.com/growth/activity/20210305/1614911293192.png">
                    </div> -->
                    <div class="swiper-slide slide-item">
                      <img src="https://s21.lgstatic.com/growth/activity/20210305/1614911306505.png">
                    </div>
                </div>
            </div>
        </div>
        <div class="title-view title-1">
            <img class="t-img" src="https://s21.lgstatic.com/growth/activity/20210305/1614912248199.png">
            <div class="t-txt">0基础，我不知道学什么？</div>
            <div class="t-des">拉勾带你了解行业发展</div>
        </div>
        <div class="tab-main">
            <div class="tab-view" v-for="(item, index) in tabList" :key="index" :class="[`tb-${index}`]" @click="JumpHerf(item.url)">
                <img class="icon" :src="item.img">
                <div class="t-name">{{item.name}}</div>
                <div class="t-des">{{item.des}}</div>
            </div>
        </div>
        <div class="btn" @click="JumpFn('2')">
            了解更多课程<img class="icon" src="https://s21.lgstatic.com/growth/activity/20210305/1614925056437.png">
        </div>
        <div class="title-view title-2">
            <img class="t-img" src="https://s21.lgstatic.com/growth/activity/20210305/1614925669701.png">
            <div class="t-txt">拉勾IT编程课  各类人群皆可学</div>
            <div class="t-des">由浅入深逐级构建开发能力</div>
        </div>
        <div class="section-2">
            <div class="section-view" v-for="(item, index) in sectionViewList" :key="index">
                <img class="img" :src="item">
            </div>
        </div>
        <div class="btn" @click="JumpFn('2')">
            测试自己是否适合学习<img class="icon" src="https://s21.lgstatic.com/growth/activity/20210305/1614925056437.png">
        </div>
        <div class="section-3">
            <div class="title-view title-2">
                <img class="t-img" src="https://s21.lgstatic.com/growth/activity/20210305/1614927038550.png">
                <div class="t-txt">从零开始学编程，拉勾助你6个月掌握编程核心技术</div>
            </div>
        </div>
        <div class="title-view title-2">
            <img class="t-img" src="https://s21.lgstatic.com/growth/activity/20210305/1614927618057.png">
            <div class="t-txt">拉勾教育荣获“2020在线教育百强”两项奖项</div>
        </div>
        <div class="section-4">
            <img src="https://s21.lgstatic.com/growth/activity/20210305/1614927763551.png">
        </div>
        <div class="title-view title-3">
            <img class="t-img" src="https://s21.lgstatic.com/growth/activity/20210305/1614927889675.png">
            <div class="t-txt">拉勾教育多样化课程  总有一课适合你</div>
        </div>
        <div class="learn-view">
            <div class="tabView">
                <div 
                    class="tab-item" v-for="(item, index) in tabBgList" :key="index"
                    :class="activeClass(index)"
                    v-on:mouseover="changeActive($event,index)"
                >
                    <div class="img" :style="{background:'url('+item.url+')'}"></div>
                    <div class="name">{{item.name}}</div>
                </div>
            </div>
            <div class="activeMain">
                <img class="icon" :style="{'left':((actveIndex * 150 + 50) + 'PX')}" src="https://s21.lgstatic.com/growth/activity/20210305/1614934386525.png">
                <img class="main" :src="tabImgList[actveIndex]">
            </div>
        </div>
        <div class="btn btn1" @click="JumpFn('1')">
            领取完整课程大纲
        </div>
        <div class="title-view title-2">
            <img class="t-img" src="https://s21.lgstatic.com/growth/activity/20210305/1614935309311.png">
            <div class="t-txt">IT编程线上课  10000+学员认可推荐</div>
        </div>
        <div class="section-sw">
            <div class="center">
                <div class="swiper-container current-wrap">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide current-slider" v-for="(item, index) in swiperList" :key="index">
                            <img :src="item.url">
                        </div>
                    </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="title-view title-2">
            <img class="t-img" src="https://s21.lgstatic.com/growth/activity/20210305/1614938523790.png">
            <div class="t-txt">8大复合场景学习方式   让学习变得轻松</div>
            <div class="t-des">复合场景学习方式  全方位辅助学习</div>
        </div>
        <img class="section-5" :src="sectionList[0]">
        <div class="title-view title-2">
            <img class="t-img" src="https://s21.lgstatic.com/growth/activity/20210305/1614938733573.png">
            <div class="t-txt">拉勾独家内推服务，务实求职每一步</div>
        </div>
        <img class="section-6" :src="sectionList[1]">
        <div class="btn btn2" @click="JumpFn('2')">
           立即咨询
        </div>
        <div class="title-view title-2">
            <img class="t-img" src="https://s21.lgstatic.com/growth/activity/20210305/1614939013482.png">
            <div class="t-txt">入学签订保障就业协议</div>
            <div class="t-des">拉勾求职绿色通道，直通一线互联网公司面试官</div>
        </div>
        <img class="section-7" :src="sectionList[2]">
        <div class="footer-icon">
            支持信用卡分期<span class="pd">手续费0利息 </span>
        </div>
        <div class="footer-icon1">
            轻松入学  助你减轻负担
        </div>
        <div class="btn btn3" @click="JumpFn('1')">
           申请一线大厂内推名额
        </div>
        <div class="footer" @click="JumpFn('1')">
            <div class="center">
                <div class="footer-txt">
                    详细【学习计划】和拉勾猎头【1V1求职指导】
                </div>
                <div class="footer-btn" >
                    免费领取
                </div>
            </div>
        </div>

        <!-- 侧边导航栏 -->
        <LaunchNav v-show="isShow" :active-tab="3" />
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import LaunchNav from '../../../components/LaunchNav/index';
import List from './1'
export default {
    name: 'SignIn',
    components: {
        LaunchNav
    },
    data() {
        return {
            isShow:true,
            List:List,
            tabList:[],
            sectionViewList:[],
            tabBgList:[],
            actveIndex:0,
            tabImgList:[],
            swiperList:[],
            sectionList:[]
        };
    },
    computed: {
        activeClass() {
            return (index) => {
                if(index == this.actveIndex) {
                    return 'active-'+ this.actveIndex
                }
                
            }
        }
    },
    mounted() {
        let temData = this.List.data.pc
        this.tabList = temData.tabList
        this.sectionViewList = temData.sectionViewList
        this.tabBgList = temData.tabBgList
        this.tabImgList = temData.tabImgList
        this.swiperList = temData.swiperList
        this.sectionList = temData.sectionList   
        this.swiperInit()

        window.addEventListener('scroll', this.scrollTopFn)
    },
    methods: { 
        JumpFn(val) {
            if(val == '1') {
                //报名
                handleJumpUrl('069d9569e7a84dbb934208ff2d1f7bfc')
            } else {
                // 点击申请调客服
                window.open('https://tb.53kf.com/code/client/90d3e270b5d355aa44bafe74fd7fe8a11/2');
            }
        },
        scrollTopFn() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            if(scroll > 950 && scroll < 1700) {
                this.isShow = false
            } else {
                this.isShow = true
            }
        },
        changeActive($event,index){
            this.actveIndex = index
        },
        JumpHerf(url) {
            if(url) {
                window.open(url)
            }
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                spaceBetween: 30
            };
            let option1 = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                spaceBetween: 30,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next'
            };
            this.$nextTick(() => {
                const swiper1 = new Swiper('.top-swiper', option);
                const swiper2 = new Swiper('.current-wrap', option1);
            });
        },
    },
    destroyed() {
      document.removeEventListener('scroll', this.scrollTopFn)
    }
};
</script>

<style scoped lang="less">
@import './style.less';
</style>
